import { ValidatorFn } from '@angular/forms';

/** Requires a value containing at least one non-whitespace character. */
export const requiredTextValidator: ValidatorFn = control =>
  control.value == null || String(control.value).trim() === '' ? { required: true } : null;
